import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';
import { TERMS_CONDITIONS_ENDPOINTS } from 'src/app/core/api/endpoints/terms-conditions.endpoints';

@Injectable({
  providedIn: 'root'
})
export class TermsConditionsService {
  private api = inject(ApiService);

  getTermsAndConditions(payload: any): Observable<any> {
    return this.api.get(TERMS_CONDITIONS_ENDPOINTS.V1.TERMS_CONDITIONS_TEMPLATES, { params: payload });
  }

  getTermAndConditionById(id: number): Observable<any> {
    return this.api.get(TERMS_CONDITIONS_ENDPOINTS.V1.TERMS_CONDITION_TEMPLATE_DETAIL(id));
  }

  createTermAndCondition(data: any): Observable<any> {
    return this.api.post(TERMS_CONDITIONS_ENDPOINTS.V1.TERMS_CONDITIONS_TEMPLATES, data);
  }

  updateTermAndCondition(id: number, data: any): Observable<any> {
    return this.api.put(TERMS_CONDITIONS_ENDPOINTS.V1.TERMS_CONDITION_TEMPLATE_DETAIL(id), data);
  }

  deleteTermAndCondition(id: number): Observable<any> {
    return this.api.delete(TERMS_CONDITIONS_ENDPOINTS.V1.TERMS_CONDITION_TEMPLATE_DETAIL(id));
  }

}
